import "reflect-metadata";
import { platformBrowser } from '@angular/platform-browser';
import { AppModuleNgFactory } from './app.module.ngfactory';
import {enableProdMode} from "@angular/core";

enableProdMode();

// noinspection JSIgnoredPromiseFromCall
platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);



// WEBPACK FOOTER //
// ./src/app/main.ts